module.exports = __webpack_public_path__ + "img/success.03bce88c.svg";